export const SALES_TAX_INVOICE = "SALES_TAX_INVOICE";
